import store from "@/store";

export default [
    {
        path: '/preapprovals',
        name: 'preapprovals',
        component: () => import('@/views/preapprovals/Preapprovals'),
        meta: {
            requiresAuth: true,
            navActiveLink: 'preapprovals',
            breadcrumb: [
                {
                    text: 'Preaprobados',
                    active: true,
                },
            ],
        },
        beforeEnter(to, from, next) {
            const role = store.state.profile.role
            if (role.name === 'Admin' || role.name === 'PreapprovalUser' || role.name === 'RealstateAdmin' || role.name === 'RealstateUser' || role.name === 'RealstateVendor') next()
            else next({ name: 'error-403' })
        },
    },
    {
        path: '/preapprovals/:id/details',
        name: 'preapprovals-details',
        props: true,
        component: () => import('@/views/preapprovals/PreapprovalsDetails'),
        meta: {
            requiresAuth: true,
            navActiveLink: 'preapprovals',
            breadcrumb: [
                {
                    text: 'Preaprobados',
                    to: '/preapprovals'
                },
                {
                    text: 'Detalles',
                    active: true,
                },
            ],
        },
        beforeEnter(to, from, next) {
            const role = store.state.profile.role
            if (role.name === 'Admin' || role.name === 'PreapprovalUser') next()
            else next({ name: 'error-403' })
        },
    },
]
